
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class AuthorizedVouchersDialog extends Serenity.EntityDialog<AuthorizedVouchersRow, any> {
        protected getFormKey() { return AuthorizedVouchersForm.formKey; }
        protected getIdProperty() { return AuthorizedVouchersRow.idProperty; }
        protected getLocalTextPrefix() { return AuthorizedVouchersRow.localTextPrefix; }
        protected getNameProperty() { return AuthorizedVouchersRow.nameProperty; }
        protected getService() { return AuthorizedVouchersService.baseUrl; }
        protected getDeletePermission() { return AuthorizedVouchersRow.deletePermission; }
        protected getInsertPermission() { return AuthorizedVouchersRow.insertPermission; }
        protected getUpdatePermission() { return AuthorizedVouchersRow.updatePermission; }

        protected form = new AuthorizedVouchersForm(this.idPrefix);

    }
}